'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Nav = function Nav(props) {
  return _react2['default'].createElement('div', props);
};

exports['default'] = Nav;


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/node_modules/_rc-editor-mention@1.0.3@rc-editor-mention/es/component/Nav.react.js
// module id = 210
// module chunks = 0